import { Component } from '@angular/core';
import { AppService, IMessage } from './app.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-root',
  providers: [AppService],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  therapeutic_approach_1 = true;
  therapeutic_approach_2 = false;
  therapeutic_approach_3 = false;
  therapeutic_approach_4 = false;
  therapeutic_approach_5 = false;
  message: IMessage = {};
  contactForm: FormGroup;
  successMail = '';
  errorMail = '';

  constructor(private appService: AppService, private fb: FormBuilder) {
    this.createForm();
  }

  createForm() {
    this.contactForm = this.fb.group({
      name: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(50)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      confirmEmail: ['', Validators.compose([Validators.required, Validators.email])],
      subject: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(100)])],
      msg: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(1000)])],
    });
  }

  sendEmail(message: IMessage) {
    this.appService.sendEmail(message).subscribe(res => {
      this.successMail = 'Votre message a été envoyé.';
      this.contactForm.reset();
    }, error => {
    });
  }

  therapeuticClick(event) {
     switch (event.currentTarget.id) {
    case 'first_contact':
        this.therapeutic_approach_1 = true;
        this.therapeutic_approach_2 = false;
        this.therapeutic_approach_3 = false;
        this.therapeutic_approach_4 = false;
        this.therapeutic_approach_5 = false;
      break;
    case 'psycho':
        this.therapeutic_approach_1 = false;
        this.therapeutic_approach_2 = true;
        this.therapeutic_approach_3 = false;
        this.therapeutic_approach_4 = false;
        this.therapeutic_approach_5 = false;
      break;
    case 'clinic':
        this.therapeutic_approach_1 = false;
        this.therapeutic_approach_2 = false;
        this.therapeutic_approach_3 = true;
        this.therapeutic_approach_4 = false;
        this.therapeutic_approach_5 = false;
      break;
    case 'traitement':
        this.therapeutic_approach_1 = false;
        this.therapeutic_approach_2 = false;
        this.therapeutic_approach_3 = false;
        this.therapeutic_approach_4 = true;
        this.therapeutic_approach_5 = false;
      break;
    case 'eval_obj':
        this.therapeutic_approach_1 = false;
        this.therapeutic_approach_2 = false;
        this.therapeutic_approach_3 = false;
        this.therapeutic_approach_4 = false;
        this.therapeutic_approach_5 = true;
      break;
    default:
        this.therapeutic_approach_1 = true;
        this.therapeutic_approach_2 = false;
        this.therapeutic_approach_3 = false;
        this.therapeutic_approach_4 = false;
        this.therapeutic_approach_5 = false;
  }
}
}



// WEBPACK FOOTER //
// /Users/agencehoffman/Desktop/Workspace/catherinet/src/app/app.component.ts